module.exports = __webpack_public_path__ + "media/images/svgs/vendor-icon-64da80e9af7c973ee698d4c342282348.svg";